var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScaleBothUp = function SvgScaleBothUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 29,
    height: 28,
    viewBox: "0 0 2.85 2.81",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14.52C1 .52.89.41.88.28c0-.14.11-.25.24-.26l.24-.01c.33-.01.62-.03.99.03h.09c.34-.01.41-.01.4.74 0 .13.01.24.01.34 0 .18 0 .34-.01.54-.01.13-.12.24-.26.23a.24.24 0 0 1-.23-.26c.01-.19.01-.34.01-.5-.01-.11-.01-.22-.01-.35.01-.24.01-.25-.07-.25-.05.01.07.01 0 0-.33-.05-.6-.04-.9-.02l-.24.01zm-1.09.57A.25.25 0 0 1 .35.9c.13.04.21.17.18.3l.01.21c.01.24.02.58-.01.88.07-.01.16-.01.25 0 .14.02.42.02.66.02h.29c.14.01.25.12.24.26 0 .13-.11.24-.25.24l-.28-.01c-.26 0-.56 0-.71-.02-.09-.01-.18.01-.25.02-.08.01-.15.02-.23 0-.19-.03-.29-.14-.24-.39.06-.29.05-.71.04-.98-.01-.16-.01-.28 0-.34z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgScaleBothUp;